import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarIcon, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { cn } from "@/lib/utils";

/** Date picker that reads and writes ISO "YYYY-MM-DD" strings. */
export function DatePicker({ value, onChange, testId, placeholder = "Pick a date", disabled, captionLayout }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid={testId}
          className={cn("h-9 w-full flex items-center gap-2 rounded-md border border-input bg-white px-3 text-sm text-left focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-50",
            !value && "text-slate-400")}>
          <CalendarIcon className="h-4 w-4 text-slate-500 shrink-0" />
          <span className="flex-1 truncate">{selected ? format(selected, "MMM d, yyyy") : placeholder}</span>
          {value && !disabled && (
            <X className="h-3.5 w-3.5 text-slate-400 hover:text-slate-700" data-testid={testId && `${testId}-clear`}
              onClick={(e) => { e.stopPropagation(); onChange(""); }} />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={testId && `${testId}-popover`}>
        <Calendar mode="single" selected={selected} defaultMonth={selected} captionLayout={captionLayout}
          fromYear={1920} toYear={new Date().getFullYear() + 10}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
